import {NavComponent} from '../../components/navbar/nav.component';
import {Jivoloader} from '../../components/jivosite/jivoloader';
import {CustomSelect} from '../../components/custom-select/custom-select';

export class FaqPage {
    constructor(
        private navComponent: NavComponent,
        private jivoLoader: Jivoloader,
        private customSelect: CustomSelect,
    ) {
    }

    public init(): void {
        this.navComponent.init();
        this.jivoLoader.init();
        this.customSelect.init();
        this.subscribeAccordionEvent();
    }

    private subscribeAccordionEvent(): void {
        const accordionItems = document.querySelectorAll('.question--header');
        accordionItems.forEach((item) => {
            item.addEventListener('click', this.accordionEventHandler.bind(this));
        });
    }

    private accordionEventHandler(event: Event): void {
        const isExtended = (event.target as HTMLDivElement).closest('.question').classList.contains('extended');
        if (isExtended) {
            return;
        }
        this.removeExtendedClass();
        this.setExtendedClass(event.target as HTMLDivElement);
    }

    private removeExtendedClass(): void {
        const accordionItems = document.querySelectorAll('.question--header');
        accordionItems.forEach((item) => {
            item.closest('.question').classList.remove('extended');
        });
    }

    private setExtendedClass(element: HTMLDivElement): void {
        element.closest('.question').classList.add('extended');
    }
}
